import Table from './ReactTable';

export default Table;
